import React, { Component } from "react";
import PropTypes from "prop-types";
import { apiUrl } from "../config/apiUrl";
import { getSessionId } from "../utils/sessionmanagement";

class DummyComponent extends Component {
  // eslint-disable-next-line
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const steps = this.props.steps;
    const name = this.props.name;
    const stepType = this.props.stepType;
    const chatFormIdentifier = this.props.chatFormIdentifier;
    const type = this.props.type;
    let identifier = this.props.identifier;
    let identifierType = this.props.identifierType;
    let value, valueStep;
    if (stepType === "option") {
      valueStep = `option${name}`;
      value = steps[valueStep].value;
    } else if (stepType === "text") {
      valueStep = `input${name}`;
      value = steps[valueStep].value;
    } else if (stepType === "rating") {
      valueStep = `rating${name}`;
      value = steps[valueStep].value;
    } else if (stepType === "multi") {
      valueStep = `multi${name}`
      value = steps[valueStep].value;
    }

    if (identifier == null && identifierType == null) {
      identifier = null;
      try {
        identifier = steps["inputEnterMobileNoEnglish"]["value"]; // english mobile_no;
      } catch (err) {
        try {
          identifier = steps["inputEnterMobileNoHindi"]["value"]; // hindi mobile_no;
        } catch (err) {}
      }
      identifierType = 1;
    }
    if (identifier !== null) {
      let url = `${apiUrl}candidate-response/`;
      let sessionId = getSessionId();
      let modifiedName = name;
      if (
        name.indexOf("Hindi") >= 0 &&
        name.indexOf("Hindi") === name.length - "Hindi".length
      ) {
        modifiedName = name.slice(0, name.length - "Hindi".length);
      } else if (
        name.indexOf("English") >= 0 &&
        name.indexOf("English") === name.length - "English".length
      ) {
        modifiedName = name.slice(0, name.length - "English".length);
      }
      let response = {
        [modifiedName]: value,
      };
      if (name === "EnterMobileNoEnglish" || name === "EnterMobileNoHindi") {
        response = {};
      }

      let body = {
        chat_identifier: chatFormIdentifier,
        session_id: sessionId,
        identifier: identifier,
        identifier_type: identifierType,
        type: type,
        response: response,
      };
      fetch(url, {
        method: "post",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((dataReceived) => {});
    }
  }
  render() {
    return <div />;
  }
}

DummyComponent.propTypes = {
  steps: PropTypes.object,
};

DummyComponent.defaultProps = {
  steps: undefined,
};

export default DummyComponent;
